import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReservationsComponent } from './components/reservations/reservations.component';



@NgModule({
  declarations: [
    ReservationsComponent
  ],
  imports: [
    CommonModule
  ]
})
export class ReservationHistoryModule { }
